module.exports = {
	"data": [
		{
			"path": "/",
			"name": "Home"
		},
		{
			"name": "Stuff",
			"path": "/links",
			"subnav": [
				{
					"path": "/links",
					"name": "Links"
				}
			]
		},
		{
			"path": "/contact",
			"name": "Contact"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/navigation.json
// module id = 342
// module chunks = 0